<ng-container *ngIf="true">
    <href [link]="component.link">
        <div class="hero-image-component overflow-hidden"
             [ngClass]="component.ratio || ''">
            <local-shell />
            <!-- image -->
            <ng-container *ngIf="component.background_image">
                <img class="rf"
                     [always]="true"
                     [image]="component.background_image">
            </ng-container>

            <ng-container *ngIf="component.video_id && !component.video_hide">
                <div class="w-12 pos-absolute top-50">
                    <div class="ratio-3-4">

                        <youtube-player class="fill"
                                        [video-id]="component.video_id"
                                        [autoplay-in-viewport]="component.video_autoplay"
                                        [background]="component.video_background"
                                        *ngIf="component.video_provider === 'youtube'">
                            <ng-template #playButton>
                                <button class="button-1"
                                        role="button">
                                    <i class="icon-play"></i>
                                </button>
                            </ng-template>

                            <ng-template #pauseButton>
                                <button class="button-1"
                                        role="button">
                                    <i class="icon-pause"></i>
                                </button>
                            </ng-template>
                        </youtube-player>

                        <vimeo-player class="fill"
                                      [video-id]="component.video_id"
                                      [autoplay-in-viewport]="component.video_autoplay"
                                      [background]="component.video_background"
                                      *ngIf="component.video_provider === 'vimeo'">
                            <ng-template #playButton>
                                <button class="button-1"
                                        role="button">
                                    <i class="icon-play"></i>
                                </button>
                            </ng-template>

                            <ng-template #pauseButton>
                                <button class="button-1"
                                        role="button">
                                    <i class="icon-pause"></i>
                                </button>
                            </ng-template>
                        </vimeo-player>

                    </div>
                </div>

            </ng-container>

            <div class="fill flex"
                 *ngIf="component.blocks && component.blocks.length">
                <div class="flex"
                     [ngClass]="[((component.width) ? component.width : 'w-12')]">
                    <div class="w-12 pos-relative">
                        <!-- blocks -->
                        <ng-container *ngFor="let block of component.blocks; let i = index">
                            <div class="pos-absolute right-0"
                                 [ngClass]="['z-' + i, block.style || '', (block.custom ? 'left-0' : '')]"
                                 [style.top.%]="(block.top_position || 0)"
                                 [style.left.%]="(block.custom ? 0 : block.left_position || 0)"
                                 [style.right.%]="(block.custom ? 0 : block.right_position || 0)">

                                <ng-container *ngIf="block.custom">
                                    <icms-outlet [components]=" block.components">
                                    </icms-outlet>
                                </ng-container>

                                <ng-container *ngIf="!block.custom">
                                    <!-- lines -->
                                    <ng-container *ngFor="let line of block.lines"
                                                  [ngSwitch]="line.type">

                                        <!-- text -->
                                        <ng-container *ngSwitchCase="'text'">
                                            <tag [tag]="line.tag">
                                                <span class="w-12"
                                                      [ngClass]="[line.align||'', line.text_style|| 'h4', line.color||'', line.style||'']"
                                                      *iCms="'text' of line"></span>
                                            </tag>
                                        </ng-container>

                                        <!-- button -->
                                        <div class="p-t-2 p-b-2"
                                             [ngClass]="[line.align||'', line.form_size||'', line.style||'']"
                                             *ngSwitchCase="'button'">
                                            <a [ngClass]="((line.button_class) ? line.button_class : '')"
                                               [routerLink]="line.button_link || component.link">
                                                <span class="button__body"
                                                      *iCms="'text' of line"
                                                      [ngClass]="line.button_class === 'button-inline' ? '' + line.color : ''"></span>
                                            </a>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </href>
</ng-container>
